<template>
  <div class="how-it-works container">
    <div class="how-it-works__title">
      <h2>{{ $t('homepage.how_it_works.title') }}</h2>
    </div>
    <ul class="how-it-works__paragraphs">
      <li v-for="item in information" :key="item" class="how-it-works__paragraphs__item">
        <h3 class="how-it-works__paragraphs__title">
          {{ $t(`homepage.how_it_works.paragraphs.${item}.title`) }}
        </h3>
        <p
          class="how-it-works__paragraphs__one"
          v-sanitize-html="$t(`homepage.how_it_works.paragraphs.${item}.text`)"
        ></p>
        <p
          class="how-it-works__paragraphs__two"
          v-sanitize-html="$t(`homepage.how_it_works.paragraphs.${item}.subtext`)"
        ></p>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const { $i18n } = useNuxtApp();

const information = ['find', 'book', 'create'];
</script>

<style lang="scss" scoped>
@use '@/assets/styles/css_BASE/helpers/mixins/font-size.scss' as *;
@use '@/assets/styles/css_BASE/helpers/mixins/_bp.scss' as *;

.how-it-works {
  margin-top: 40px;
  background-color: var(--color-night-blue-900);
  padding: 20px;
  color: white;

  @include bp(sm) {
    background: left / contain no-repeat url('/assets/artnight/homepage/how-it-works/desktop-background.png');
    background-color: var(--color-night-blue-900);
    background-size: 500px;
  }

  @include bp(md) {
    background-image: none;
    padding-right: 0px;
    display: flex;
    padding-left: 0px;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  &__title {
    color: white;
    background: top / contain no-repeat url('/assets/artnight/homepage/how-it-works/title-background.png');
    text-align: right;
    @include font-size(33px);
    padding-top: 80px;

    @include bp(sm) {
      @include font-size(28px);
      margin-left: 0px;
      padding: 0px;
      background-image: none;
      min-width: 250px;
    }
    @include bp(md) {
      @include font-size(34px);
      margin-left: 0px;
      padding: 50px;
      display: flex;
      align-items: center;
    }

    @include bp(lg) {
      @include font-size(34px);
      margin-left: 100px;
      background-size: 380px;
      height: 400px;
    }
    h2 {
      font-weight: 700;
      padding: 0px 20px;
      letter-spacing: 2px;
    }
  }
  ul {
    list-style-type: none;
    padding-left: 0; /* Optional: Remove the left padding */
  }
  &__paragraphs {
    background: bottom / contain no-repeat url('/assets/artnight/homepage/how-it-works/text-background.png');
    padding: 30px 10px;
    @include bp(sm) {
      background-image: none;
    }

    @include bp(md) {
      background: top right / contain no-repeat
        url('/assets/artnight/homepage/how-it-works/text-background-desktop.png');
      background-size: 300px;
      padding-right: 100px;
      margin-right: 0px;
    }

    @include bp(md) {
      background: top right / contain no-repeat
        url('/assets/artnight/homepage/how-it-works/text-background-desktop.png');
      background-size: 300px;
      padding-right: 200px;
      margin-right: 0px;
    }

    &__title {
      @include font-size(30px);
      font-weight: 700;
      line-height: 36px;
      letter-spacing: -2%;
      padding-bottom: 15px;
    }

    p {
      @include font-size(16px);
      line-height: 48px;
      letter-spacing: 0%;
      line-height: 130%;
      padding-bottom: 15px;
    }
  }
}
</style>
